import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Placeholder", -1)
const _hoisted_3 = { class: "settings-row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Comparison Type", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<option value=\"-1\">Text equals</option><option value=\"0\"> &lt; </option><option value=\"1\"> &lt;= </option><option value=\"2\"> = </option><option value=\"3\"> &gt;= </option><option value=\"4\"> &gt; </option>", 6)
const _hoisted_11 = { class: "settings-row" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Value", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.action.placeholder = $event))
      }, null, 512), [
        [_vModelText, _ctx.action.placeholder]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.compType = $event))
      }, [
        _hoisted_5
      ], 512), [
        [
          _vModelSelect,
          _ctx.action.compType,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _hoisted_12,
      _withDirectives(_createVNode("input", {
        type: _ctx.action.compType == -1 ? 'text' : 'number',
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.action.value = $event))
      }, null, 8, ["type"]), [
        [_vModelDynamic, _ctx.action.value]
      ])
    ]),
    (_ctx.action.compType == -1)
      ? (_openBlock(), _createBlock("p", _hoisted_13, " Checks whether the placeholder " + _toDisplayString(_ctx.action.placeholder) + " has the value \"" + _toDisplayString(_ctx.action.value) + "\" ", 1))
      : (_openBlock(), _createBlock("p", _hoisted_14, " Checks whether: " + _toDisplayString(_ctx.action.placeholder) + " " + _toDisplayString(_ctx.compText) + " " + _toDisplayString(_ctx.action.value), 1))
  ]))
}